import { gql } from "@apollo/client";

export const modelByArticleNumberQuery = gql`
    query ModelByArticleNumber($articleNumber: String!, $brandIds: [ID!]) {
        modelByArticleNumber(articleNumber: $articleNumber, brandIds: $brandIds) {
            id
        }
    }
`;
